import { OrderStatus, OrderStatusLabel } from "@constant/OrderStatus";
import { RegionType } from "@constant/ThroughShipment";
import { dealerState, fetchRetailList } from "@redux/dealerSlice";
import { onlineOrderState, setOrderListFilter } from "@redux/onlineOrderSlice";

import React, { useEffect } from "react";
import { Button, Col, Form, Row, Select, Input, DatePicker } from "antd";
import locale from "antd/es/date-picker/locale/zh_TW";
import moment from "moment";
import { useSelector } from "react-redux";
import styled from "styled-components";

import { useAppDispatch } from "src/store";

const CustomRangePicker = styled(DatePicker.RangePicker)`
  width: 100%;
`;
const Wrapper = styled(Form)`
  padding: 24px 0px 0px 16px;
`;
const CustomButton = styled(Button)`
  margin-right: 10px;
`;

// 線上出貨訂單可篩選的狀態
const orderStatusOptions = [
  OrderStatus.CANCEL,
  OrderStatus.DESTROYED,
  OrderStatus.WAITING_DEPLOY,
  OrderStatus.PROCESSING,
  OrderStatus.PICKING,
  OrderStatus.OUT_OF_STOCK,
  OrderStatus.ALREADY_SHIPPED,
  OrderStatus.SHIPPING_ABNORMAL,
  OrderStatus.FINISH,
].map((status) => ({ value: status, label: OrderStatusLabel[status] }));

export default function ExternalOrderFilter() {
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();
  const { orderListFilter } = useSelector(onlineOrderState);
  const { retailList } = useSelector(dealerState);

  const onReset = () => {
    form.resetFields();
    dispatch(
      setOrderListFilter({
        limit: orderListFilter.limit,
        offset: 0,
      }),
    );
  };

  const onSubmit = (values: any) => {
    dispatch(
      setOrderListFilter({
        ...orderListFilter,
        orderNumber: values.orderNumber,
        warehouseCode: values.warehouseCode,
        platformNumber: values.platformNumber,
        sku: values.sku,
        platform: values.platform,
        status: values.shippingStatus,
        estimatedShippingDateAfter: values.estimatedShippingDate
          ? moment(values.estimatedShippingDate[0]).format("YYYY-MM-DD")
          : undefined,
        estimatedShippingDateBefore: values.estimatedShippingDate
          ? moment(values.estimatedShippingDate[1]).format("YYYY-MM-DD")
          : undefined,
        shippingDateAfter: values.shippingDate ? moment(values.shippingDate[0]).format("YYYY-MM-DD") : undefined,
        shippingDateBefore: values.shippingDate ? moment(values.shippingDate[1]).format("YYYY-MM-DD") : undefined,
        createdAt: undefined,
        shippingAt: undefined,
      }),
    );
  };

  const warehouseCodeOptions = [
    { label: "藍田", value: "RENTRAP" },
    { label: "黑貓", value: "TCAT" },
  ];

  const options = retailList.results.map((item) => ({
    value: item.name,
    label: item.name,
    id: item.id,
  }));

  useEffect(() => {
    dispatch(fetchRetailList({ regionTypes: RegionType.DOMESTIC_ONLINE }));
  }, [dispatch]);

  return (
    <Wrapper
      labelCol={{
        span: 6,
      }}
      colon={false}
      labelAlign="left"
      form={form}
      initialValues={{}}
      onFinish={onSubmit}
    >
      <Row gutter={[12, 4]}>
        <Col span={8}>
          <Form.Item label="訂單編號" name="orderNumber">
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="出貨倉庫" name="warehouseCode">
            <Select placeholder="請選擇" options={warehouseCodeOptions} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="通路平台" name="platform">
            <Select placeholder="請選擇" options={options} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[12, 4]}>
        <Col span={8}>
          <Form.Item label="SKU(品號)" name="sku">
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="平台訂單編號" name="platformNumber">
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="訂單狀態" name="shippingStatus">
            <Select placeholder="請選擇" allowClear options={orderStatusOptions} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[12, 4]}>
        <Col span={8}>
          <Form.Item label="預計出貨時間" name="estimatedShippingDate">
            <CustomRangePicker locale={locale} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="實際出貨時間" name="shippingDate">
            <CustomRangePicker locale={locale} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={30}>
        <Col span={24}>
          <Row justify="end">
            <CustomButton onClick={onReset}>清除篩選條件</CustomButton>
            <Button type="primary" htmlType="submit">
              套用
            </Button>
          </Row>
        </Col>
      </Row>
    </Wrapper>
  );
}
